module.exports = __webpack_public_path__ + "static/media/NodeJs.5b47d4f8.png";